import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useUpgradeMembershipContext } from '../../utils/ContextProviders/UpgradeContext';
import { getImagesStaticUrl } from '../../helpers';

const MobileTable = ({ getCouponContentKey }) => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { variables } = growthUpgrade;
  const perks = variables.perks?.list ?? [];

  const perksList = perks.filter((perk) => !perk.skip.seasonal);

  return (
    <div className="desktop-hidden">
      <table className="upgrade-plan-table">
        <tbody>
          <tr className="placeholder-row">
            <th />
            <th />
            <th className="table-header table-header__annual annual-border">
              <img
                src={getImagesStaticUrl(
                  getCouponContentKey('bestValueImag', 'best-value-mobile.svg'),
                )}
                alt="best value"
              />
            </th>
          </tr>
          <tr>
            <th className="table-header__feature table-header">
              {getCouponContentKey('header1', 'Feature')}
            </th>
            <th className="table-header__seasonal table-header border-right-none">
              {getCouponContentKey('header2', 'Seasonal')}
            </th>
            <th className="table-header table-header__annual annual-border">
              {getCouponContentKey('header3', 'Annual')}
            </th>
          </tr>
          {perksList.map(({ label, mobileLabel, check }, index) => (
            <Fragment key={label}>
              <tr className="feature-row">
                <th className="table-features">{mobileLabel || label}</th>
                <td>
                  <i
                    className={cx('far', {
                      'fa-times': !check.seasonal,
                      'times-icon': !check.seasonal,
                      'fa-check': check.seasonal,
                      'check-icon': check.seasonal,
                    })}
                  />
                </td>
                <td
                  className={cx('annual-side-border', {
                    'annual-bottom-border': perksList.length - 1 === index,
                  })}
                >
                  <i className="far fa-check check-icon" />
                </td>
              </tr>
              <tr className="table-divider" />
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

MobileTable.defaultProps = {
  showAdditionalPerks: false,
};

MobileTable.propTypes = {
  showAdditionalPerks: PropTypes.bool,
};

export default MobileTable;
